/**
 * 描述：视频素材左侧导航
 * 日期：2019-6-24
 * 作者：nxf
 */
"use strict";
angular.module("resCenVideoLeftModule", [])
    .directive("videoLeft", ["$q", "$state", "$stateParams", "trsHttpService", function($q, $state, $stateParams, trsHttpService) {
        return {
            replace: false,
            restrict: "E",
            scope: {
                treeModel: "="
            },
            templateUrl: "./resourceCenter/multiMediaResource/video/left/left_tpl.html",
            link: function($scope, $elem, $attrs) {
                initStatus();
                initData();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {};
                }
                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    getLeftList().then(function(data) {                    
                        autoLocation();
                    });
                }
                /**
                 * [autoLocation description] 自动定位
                 * @return {[type]} [description]
                 */
                function autoLocation() {
                    var flag = false;
                    var childNode =false;
                    for (var i in $scope.data.treeData) {
                        var data = $scope.data.treeData[i];
                        if (data.mediaId === $stateParams.mediaId) {
                            flag = true;
                            childNode =true;
                            $scope.status.isSelected = data;              
                            break;
                        } 
                    }
                    if (!flag) {
                       // firstGet($scope.data.treeData[0],childNode);
                       goTo($scope.data.treeData[0]);
                     //  console.log("dd")
                       
                    }else{
                        firstGet($scope.status.isSelected,childNode);
                        console.log("11")
                    }
                   
                }
                /**
                 * [getLeftList description] 获取左侧列表
                 * @return {[type]} [description]
                 */
                function getLeftList() {
                    var deffer = $q.defer();
                    let params = {
                        typeid: "zyzx",
                        serviceid: "navigation",
                        modelId: 'getWebVideoMedia'
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                        $scope.data.treeData = data; 

                        deffer.resolve(data);
                    });
                    return deffer.promise;
                }
                /**
                 * [showSelected description] 选中节点
                 * @param  {[type]} node [description] 所选节点
                 * @return {[type]}      [description]
                 */
                $scope.firstClick = function(event, node) {
                    if (event.stopPropagation) event.stopPropagation();
                    var deffer = $q.defer();
                    let params = {
                        typeid: "zyzx",
                        serviceid: "navigation",
                        modelId: 'getWebVideoChannel',
                        mediaId:node.mediaId
                    };
                  
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                         node.CHILDLIST =data;
                         goTo(node);
                         deffer.resolve(data);
                    });
                    return deffer.promise;
                  
                };
                //模拟点击获取子菜单
                function firstGet(node,childNode){
                    var deffer = $q.defer();
                    let params = {
                        typeid: "zyzx",
                        serviceid: "navigation",
                        modelId: 'getWebVideoChannel',
                        mediaId:node.mediaId
                    };                 
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(childdata) {
                         node.CHILDLIST =childdata;
                         node.isOpen = true;
                         if(!childNode){
                            goTo(node.CHILDLIST[0]);
                         }else{
                            for (var j in node.CHILDLIST) {
                                var child = node.CHILDLIST[j];
                                if (child.hybaseId === $stateParams.hybaseId) {                                  
                                    goTo(child); 
                                    break;                                  
                                }
                            }
                             
                         }
                        
                         deffer.resolve(childdata);
                    });
                    return deffer.promise;
                }

                /**
                 * [secondClick description] 点击二级彩电
                 * @param  {[type]} node [description] 所选节点
                 * @return {[type]} [description]
                 */
                $scope.secondClick = function(event, item, items) {
                    event.stopPropagation();                                     
                    goTo(item);
                };
                /**
                 * [goTo description] 页面跳转
                 * @return {[type]} [description]
                 */
                function goTo(node) {
                    $scope.status.isSelected = node;
                    $state.go("front.resourcectrl.multimediaresource.video", {
                        typename: 'push',
                        mediaId: node.mediaId,
                        hybaseId:node.hybaseId,
                        change: Math.random(0, 1) * 100,
                    }, { reload: "front.resourcectrl.multimediaresource.video" });
                }
                /**
                 * [initStatus description] 展开和选中样式
                 * @return {[type]} [description]
                 */
                $scope.expandNode = function(event, items) {
                    event.stopPropagation();
                    items.isOpen = !items.isOpen;
                };
            }
        };
    }]);